<div class="tab-content">
  <div
    *ngIf="overview?.type"
    class="item overview"
  >
    <h5>{{overview.type}}</h5>
    <span>{{overview.text}}</span>
  </div>
  <div
    *ngFor="let experience of experiences; trackBy: trackElement"
    class="item"
  >

    <h5>{{ experience?.jobTitle | mojoHighlight: keywords }}</h5>

    <dl class="row">
      <dt class="col-md-2">Company:</dt>
      <dd class="col-md-10">
        {{ experience?.employerName | mojoHighlight: keywords }}
      </dd>

      <dt class="col-md-2">Dates:</dt>
      <dd class="col-md-10">{{ experience?.period }}</dd>
    </dl>

    <ul class="list">
      <li
        *ngFor="let summary of experience?.responsibilites"
        [innerHtml]="summary | mojoHighlight: keywords"
      >
      </li>
    </ul>

  </div>
</div>
